<!-- InputRadio.vue -->

<script setup>
import { computed } from 'vue';

const props = defineProps({
  name: String,
  id: String,
  value: [String, Number],
  modelValue: [String, Number],
});

const emit = defineEmits(['update:modelValue']);

const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});
</script>
<template>
  <div class="custom-radio-wrapper">
    <input
      :id="id"
      class="custom-radio-input"
      type="radio"
      :name="name"
      :value="value"
      v-model="internalValue"
    />
    <label class="custom-radio-label ms-2" :for="id">
      <slot />
    </label>
  </div>
</template>

<style scoped>
.custom-radio-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.custom-radio-input {
  display: none; /* ซ่อน CSS Radio เดิม */
}

.custom-radio-label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 0;
  font-size: 13px!important;
  font-weight: 300;
}


.custom-radio-label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 19px;
  width: 19px;
  border: 5px solid #ccc; 
  border-radius: 50%;
  background-color: white; 
}


.custom-radio-input:checked + .custom-radio-label::before {
  border-color: orange;
}


.custom-radio-input:checked + .custom-radio-label::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  height: 8px;
  width: 8px;
  background-color: white; /* จุดสีขาว */
  border-radius: 50%;
}

</style>
